import axios from 'axios';
import { getAuthData } from '../../../utils/authStorage';

const API = axios.create({
  baseURL: process.env.REACT_APP_PEGASUS_API_URL
});

const normalizeMailbox = (mailbox) => ({
  ...mailbox,
  id: mailbox?.id || mailbox?._id,
});

// Add authorization header and encrykey to all requests
API.interceptors.request.use(
  (config) => {
    const authData = getAuthData();
    const token = authData?.token || sessionStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    config.headers.ENCRYKEY = process.env.REACT_APP_KEY_PEGASUS;
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Mailboxes
export const fetchMailboxes = () => API.get('/api/mailboxes').then(r => (Array.isArray(r.data) ? r.data : r.data?.mailboxes || []).map(normalizeMailbox));
export const createMailbox = (payload) => API.post('/api/mailboxes', payload).then(r => normalizeMailbox(r.data));
export const fetchMailbox = (id) => API.get(`/api/mailboxes/${id}`).then(r => normalizeMailbox(r.data?.mailbox || r.data));
export const updateMailbox = (id, payload) => API.put(`/api/mailboxes/${id}`, payload).then(r => normalizeMailbox(r.data));
export const deleteMailbox = (id) => API.delete(`/api/mailboxes/${id}`).then(r => r.data);
export const mailboxFolders = (id) => API.get(`/api/email/mailboxes/${id}/folders`).then(r => Array.isArray(r.data) ? r.data : r.data?.folders || []);
export const mailboxFolderMessages = (mailboxId, folder, params) => API.get(`/api/email/mailboxes/${mailboxId}/folders/${encodeURIComponent(folder)}/messages`, { params }).then(r => r.data);
export const mailboxMessageDetail = (mailboxId, folder, uid) => API.get(`/api/email/mailboxes/${mailboxId}/folders/${encodeURIComponent(folder)}/messages/${uid}`).then(r => r.data);
export const mailboxMessageAction = (mailboxId, folder, uid, payload) => API.post(`/api/email/mailboxes/${mailboxId}/folders/${encodeURIComponent(folder)}/messages/${uid}/action`, payload).then(r => r.data);
export const mailboxAttachment = (mailboxId, folder, uid, partId, config = {}) => API.get(`/api/email/mailboxes/${mailboxId}/folders/${encodeURIComponent(folder)}/messages/${uid}/attachments/${partId}`, { ...config, responseType: 'blob' }).then(r => r.data);
export const mailboxHealth = (mailboxId) => API.get(`/api/email/mailboxes/${mailboxId}/health`).then(r => r.data);
export const mailboxSync = (mailboxId) => API.post(`/api/email/sync/${mailboxId}`).then(r => r.data);

// Unified
export const fetchUnifiedInbox = (params) => API.get('/api/email/unified/inbox/messages', { params }).then(r => r.data);
export const fetchThread = (messageId) => API.get(`/api/email/messages/${messageId}/thread`).then(r => r.data);

// Sending
export const sendMail = (payload) => API.post('/api/email/send', payload).then(r => r.data);
export const replyMail = (mailboxId, payload) => API.post(`/api/email/send/${mailboxId}/reply`, payload).then(r => r.data);

export default API;
